import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from 'src/app/services/admin/admin.service';
declare var $: any;
@Component({
  selector: 'app-invoice-generate-modal',
  templateUrl: './invoice-generate-modal.component.html',
  styleUrls: ['./invoice-generate-modal.component.scss']
})
export class InvoiceGenerateModalComponent {
  @Input() modelId: any;
  @Input() modalName: string;
  @Input() loading: boolean;
  @Input() type: string;
  @Input() shops: any;
  @Input() brands: any;
  @Input() showSendInvoice: string;
  @Input() selectedInvoice: any;

  @Output() clearData = new EventEmitter();
  @Output() showAllInvoices = new EventEmitter();

  generated: boolean = false
  generatedSuccess: boolean = false
  message: string = ''
  sendInvoice: boolean = false
  sentSuccess: boolean = false
  sentMessage: string = ''
  sentLoading: boolean = false
  today: string = moment(Date()).format('YYYY-MM-DD')

  commissionForm: FormGroup = new FormGroup({
    from_date: new FormControl('', [Validators.required]),
    to_date: new FormControl('', [Validators.required]),
    brand_id: new FormControl(''),
    outlet_code: new FormControl('', [Validators.required]),
    type: new FormControl(null, [Validators.required]),
  })
  get controls() { return this.commissionForm.controls; }
  sendForm: FormGroup = new FormGroup({
    invoice_id: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email, Validators.pattern(
      '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,63}$',
    )]),
  })
  get sendControls() { return this.sendForm.controls; }
  constructor(
    private adminService: AdminService, private spinner: NgxSpinnerService,) { }

  ngOnChanges() {
    this.spinner.show()
    this.commissionForm.reset()
    this.commissionForm.patchValue({
      brand_id: '',
      outlet_code: '',
      type: this.type
    })
    this.sendForm.reset()
    $('#spicker_shop').selectpicker('refresh');
    $('#spicker_shop_brand').selectpicker('refresh');
  }

  onSaveChanges() {
    this.generated = false
    this.sendInvoice = false
    this.clearData.emit('')
  }

  onClick() {
    this.generated = false
    this.sendInvoice = false
    this.showAllInvoices.emit()
    this.clearData.emit('')
    this.commissionForm.reset()
  }

  onGenerateClick() {
    this.generated = true
    this.loading = true

    if (this.commissionForm.invalid) {
      console.log("form is invalid");
      this.loading = false;
    } else {
      if (moment(this.commissionForm.value.to_date).diff(moment(this.commissionForm.value.from_date)) >= 0) {
        // console.log(this.commissionForm.value);
        const formData = new FormData();
        formData.append('from_date', this.commissionForm.value.from_date)
        formData.append('to_date', this.commissionForm.value.to_date)
        formData.append('outlet_code', this.commissionForm.value.outlet_code)
        formData.append('type', this.commissionForm.value.type)
        if (this.commissionForm.value.type == 'Orders') {
          formData.append('brand_id', this.commissionForm.value.brand_id)
        }

        this.adminService.createInvoice(formData)
          .subscribe({
            next: (res) => {
              console.log(res, "sucess");
              this.loading = false;
              this.generatedSuccess = true;
              this.showSendInvoice = "success"
              this.generated = false
            },
            error: (error) => {
              console.log(error);
              this.loading = false;
              this.generatedSuccess = false;
              this.message = error != '' ? error : 'Error generating the invoice'
            }
          })
      } else {
        this.message = 'Invalid start date'
        this.loading = false;
      }
    }

  }

  onSendInvoices() {
    this.sendInvoice = true;
    this.sentLoading = true;
    this.sendForm.patchValue({
      invoice_id: this.selectedInvoice?.id
    })
    if (this.sendForm.invalid) {
      console.log("form is invalid");
      this.sentLoading = false;
    } else {
      console.log(this.sendForm.value);
      const formData = new FormData();
      formData.append('invoice_id', this.sendForm.value.invoice_id)
      formData.append('email', this.sendForm.value.email)

      this.adminService.sendInvoice(formData)
        .subscribe({
          next: (res) => {
            console.log(res, "sucess");
            this.sentLoading = false;
            this.sentSuccess = true;
            this.sendForm.reset()
            this.clearData.emit('')
            this.sendInvoice = false;
          },
          error: (error) => {
            console.log(error);
            this.sentLoading = false;
            this.sentSuccess = false;
            this.sentMessage = 'Error sending your generated invoice'
          }
        })
    }
    // this.showSendInvoice = 'success'
  }
}
